/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import UI_CONSTANTS from '../../../../constants/uiConstants';
import ScrollAwareDropShadow from '../../../components/ScrollAwareDropShadow';
import { useBottomDrawer } from './BottomDrawer';

export const AppNavFileDetail = (props) => {
  const [state] = useBottomDrawer();

  return (
    <div
      className="bkgd-color-profile-accent"
      style={{
        position: 'sticky',
        top: 0,
        paddingTop: UI_CONSTANTS.appTopPadding + 20,
        paddingBottom: 20,
        zIndex: 3,
      }}
    >
      <ScrollAwareDropShadow scrollPercent={state.scrollPos / 100} />
      <div className="util-application-content-padding">
        <div className="util-application-content-padding" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30 }}>
          {props.children}
        </div>
      </div>
    </div>
  );
};
